// in App.js
import * as React from 'react';
import { Admin, Resource } from 'react-admin';
import graphDataProvider from "./helpers/graphDataProvider";
import addUploadCapabilities from "./helpers/fileUpload";
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFnsV3';
import { ThemeProvider } from '@mui/styles';
import ApplicationEntity from './entities/application'
import RecordEntity from './entities/record'
import PostEntity from './entities/posts'
import AccountHolderEntity from './entities/accountHolder'
import PaymentPeriodEntity from './entities/paymentPeriod'
import authProvider from "./helpers/authProvider";
import MyLayout from "./uiComponents/layout";
import Themes from "./themes";
import PeopleIcon from "@mui/icons-material/PeopleOutline"
import HistoryIcon from "@mui/icons-material/InputOutlined"
import PostsIcon from "@mui/icons-material/LocalPostOfficeOutlined"
import VisitEntity from "./entities/visit"
import UserEntity from './entities/user'
import { canManageUsers } from './helpers/roles'
import VisitIcon from "@mui/icons-material/ViewAgendaOutlined"
import AccountHolderIcon from "@mui/icons-material/AccountBalanceOutlined"
import PaymentsIcon from "@mui/icons-material/PaymentsOutlined"
import UsersIcon from "@mui/icons-material/AdminPanelSettingsOutlined"
import { QueryClient } from '@tanstack/react-query';
const dataProvider = addUploadCapabilities(graphDataProvider);
const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            refetchOnWindowFocus: false, // Prevents refetching when switching tabs
            staleTime: 0,    
             refetchOnMount: false,       // Prevents refetching when navigating back              // Always consider data stale to ensure fresh getOne on show
        },
    },
});
const App = () => {
    return (
        <LocalizationProvider dateAdapter={AdapterDateFns}>
            <ThemeProvider theme={Themes.default}>
            <Admin queryClient={queryClient} darkTheme={null} theme={Themes.default} layout={MyLayout} authProvider={authProvider} dataProvider={dataProvider}>
                {(permissions = []) => {
                    // react-admin calls this with the resolved permissions, but
                    // that value is undefined until getPermissions settles - and
                    // an undefined slipping into .includes used to throw during
                    // mount. react-admin treats that as a failed auth and signs
                    // the user back out, so login could never complete. Default
                    // to no permissions; the resolvers guard every call anyway.
                    const perms = permissions || [];
                    return (
                    <>
                        <Resource icon={HistoryIcon}  name="Application" {...ApplicationEntity}  />
                        <Resource icon={PeopleIcon} name="Record" {...RecordEntity} create={(perms.includes('handler')||perms.includes('admin')) ? RecordEntity.create : null} edit={(perms.includes('handler')||perms.includes('admin')) ? RecordEntity.edit : null}  />
                        {/* <Resource icon={VisitIcon} name="Visit" {...VisitEntity}  /> */}
                        {(perms.includes('handler') ||  perms.includes('admin'))
                            ?    <Resource icon={VisitIcon} name="Visit"     {...VisitEntity} create={(perms.includes('handler')||perms.includes('admin')) ? VisitEntity.create : null}  />
                            : null}
                        <Resource icon={PostsIcon} name="Post" {...PostEntity}  />
                        {/* Payments are gated in the resolver as well as here.
                            This hides the entries; requireFinance is what
                            actually refuses the calls. */}
                        {(perms.includes('finance') || perms.includes('financeAdmin'))
                            ? <>
                                <Resource icon={PaymentsIcon} name="PaymentPeriod" {...PaymentPeriodEntity} options={{ label: 'Payments' }} />
                                <Resource icon={AccountHolderIcon} name="AccountHolder" {...AccountHolderEntity} options={{ label: 'Account Holders' }} />
                            </>
                            : null}
                        {/* Users, gated in the resolver as well as here. This hides
                            the entry; requireUserManagement is what refuses the
                            calls. canManageUsers still admits 'admin', which is
                            TEMPORARY - see the comment in helpers/roles.js and
                            USER_MANAGEMENT_ROLES in finadmin_server/server/auth/roles.js.
                            Change both together. */}
                        {canManageUsers(perms)
                            ? <Resource icon={UsersIcon} name="User" {...UserEntity} options={{ label: 'Users' }} />
                            : null}
                    </>
                    );
                }}
            </Admin>
            </ThemeProvider>
        </LocalizationProvider>
    );
};
export default App;
